<template>
  <div class="manage">
    <div class="manage-header">
      <common-form inline :formLabel="formLabel" :form="searchFrom">
        <el-button type="primary" @click="getList(searchFrom.keyword)">搜索</el-button>
      </common-form>
    </div>
    <cont-find-table :tableData="tableData" :tableLabel="tableLabel" :config="config" @changePage="getList()"></cont-find-table>
  </div>
</template>

<script>
import ContFindTable from '../../components/ContFindTable'
import CommonForm from '../../components/CommonForm'
import { getActionLogApi } from '../../api/getData'

export default {
  components: {
    ContFindTable,
    CommonForm
  },
  data() {
    return {
      operateType: 'add',
      isShow: false,
      tableData: [],
      tableLabel: [
        {
          prop: 'actionDes',
          label: '操作描述',
          width: 250
        },
        {
          prop: 'actionIp',
          label: '用户IP'
        },
        {
          prop: 'username',
          label: '用户名'
        },
        {
          prop: 'actionTime',
          label: '操作时间',
          width: 250
        },
        {
          prop: 'actionMethod',
          label: '调用方法',
          width: 600
        },
        {
          prop: 'userId',
          label: '用户ID',
          width: 250
        }
      ],
      config: {
        page: 1,
        size: 8,
        total: 0,
        loading: true
      },

      searchFrom: {
        keyword: ''
      },
      formLabel: [
        {
          model: 'keyword',
          label: '',
          placeholder: '用户名'
        }
      ]
    }
  },
  methods: {
    getList(val) {
      this.config.loading = true
      this.config.size = 8
      // 搜索时，页码需要设置为1，才能正确返回数据，因为数据是从第一页开始返回的
      val ? (this.config.page = 1) : ''
      //调用查询接口
      getActionLogApi(this.config.page, this.config.size, val).then(res => {
        res = res.data
        this.tableData = res.data
        this.config.total = res.total
        this.config.size = res.pageSize
        this.config.loading = false
      })
    }
  },
  created() {
    this.getList()
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/scss/common';
</style>
